module.exports = __webpack_public_path__ + "static/media/game-interviewer13.2ea7713e.png";